(() => {
  if (window.__oazarSpotlightReady) {
    window.__oazarSpotlightRefresh?.();
    return;
  }
  window.__oazarSpotlightReady = true;
  const roots = new Set();

  function init(root) {
    if (roots.has(root)) return;
    roots.add(root);
    const triggers = [...root.querySelectorAll('[data-ozs-trigger]')];
    const features = [...root.querySelectorAll('[data-ozs-feature]')];
    const details = [...root.querySelectorAll('[data-ozs-detail]')];
    const rail = root.querySelector('.ozs__topics');
    const previous = root.querySelector('[data-ozs-prev]');
    const next = root.querySelector('[data-ozs-next]');

    function updateArrows() {
      if (!rail) return;
      const end = rail.scrollWidth - rail.clientWidth;
      if (previous) previous.hidden = rail.scrollLeft <= 3;
      if (next) next.hidden = end <= 3 || rail.scrollLeft >= end - 3;
    }

    rail?.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows, { passive: true });
    previous?.addEventListener('click', () => rail.scrollBy({ left: -rail.clientWidth * .7, behavior: 'smooth' }));
    next?.addEventListener('click', () => rail.scrollBy({ left: rail.clientWidth * .7, behavior: 'smooth' }));
    requestAnimationFrame(updateArrows);

    function activate(index) {
      triggers.forEach((trigger, i) => {
        const active = i === index;
        trigger.classList.toggle('is-active', active);
        trigger.setAttribute('aria-pressed', String(active));
      });
      features.forEach((feature, i) => {
        const active = i === index;
        feature.classList.toggle('is-active', active);
        feature.setAttribute('aria-hidden', String(!active));
        feature.inert = !active;
      });
      details.forEach((detail, i) => {
        detail.classList.toggle('is-active', i === index);
        detail.hidden = i !== index;
      });
      if (matchMedia('(max-width: 749px)').matches && rail && triggers[index]) {
        const selected = triggers[index];
        rail.scrollTo({ left: selected.offsetLeft - rail.offsetLeft - (rail.clientWidth - selected.offsetWidth) / 2, behavior: 'smooth' });
      }
    }

    triggers.forEach((trigger, index) => {
      trigger.addEventListener('pointerenter', () => {
        if (matchMedia('(hover: hover)').matches) activate(index);
      });
      trigger.addEventListener('focus', () => activate(index));
      trigger.addEventListener('click', () => activate(index));
      trigger.addEventListener('keydown', event => {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        event.preventDefault();
        const next = (index + (event.key === 'ArrowDown' ? 1 : -1) + triggers.length) % triggers.length;
        triggers[next]?.focus();
      });
    });
    root.addEventListener('shopify:block:select', event => {
      const feature = event.target.closest('[data-ozs-feature]');
      if (feature) activate(Number(feature.dataset.ozsFeature));
    });
  }

  function refresh() {
    document.querySelectorAll('[data-ozs]').forEach(init);
    for (const root of roots) if (!root.isConnected) roots.delete(root);
  }

  window.__oazarSpotlightRefresh = refresh;
  document.addEventListener('shopify:section:load', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
